import {
    AnyAction,
} from 'redux'
import Logout from './Logout'
import {
    MapDispatch,
} from './types'
import {
    ThunkDispatch,
} from '@reduxjs/toolkit'
import {closeSession} from 'api/action/closeSession'
import {
    connect,
} from 'react-redux'


const mapDispatch = (dispatch: ThunkDispatch<null, null, AnyAction>): MapDispatch => ({
    logout: async (): Promise<void> => {
        await dispatch(closeSession())
    },
})
export default connect(null, mapDispatch)(Logout)
